import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import PageHeader from './PageHeader'
import ValidPeriod from './ValidPeriod'

function CreateUpdateCheque() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()

	const [poses, setPoses] = useState([])
	const [data, setData] = useState({
		"name": "",
		"discount_payment_type": 2,
		"items": [],
		"poses": [],
	})

	async function createUpdate() {
		var dataCopy = { ...data }

		var response
		if (!dataCopy.id) {
			response = await POST('/discount/services-cheque-manual', dataCopy, { loader: true })
		} else {
			response = await PUT('/discount/services-cheque-manual', dataCopy, { loader: true })
		}

		if (httpOk(response)) navigate(-1)
	}

	function addItem() {
		var dataCopy = { ...data }
		var item = {
			"name": "",
			"discount_payment_value": "",
		}
		dataCopy.items.push(item)

		setData(dataCopy)
	}

	function handleChange(e, index, type) {
		var dataCopy = { ...data }

		if (type === 'name') {
			dataCopy.items[index]['name'] = e.target.value
		}
		if (type === 'discount_payment_value') {
			dataCopy.items[index]['discount_payment_value'] = e.target.value
		}

		setData(dataCopy)
	}

	async function deleteItem(item, index) {
		var dataCopy = { ...data }
		if (item.id) {
			const response = await DELETE(`/discount/services-cheque-manual/${item.id}`, {}, { loader: true })
			if (httpOk(response)) dataCopy.items.splice(index, 1)
		} else {
			dataCopy.items.splice(index, 1)
		}

		setData(dataCopy)
	}


	async function getData() {
		const response = await GET('/helper/poses', {}, { loader: true })
		if (httpOk(response)) setPoses(response.data)
		if (id) {
			const response = await GET(`/discount/services-cheque-manual/${id}`, {}, { loader: true })
			if (httpOk(response)) setData(response.data)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<PageHeader typeKey="discount_manual_cheque" />

			<div className="card mb-3">
				<div className="card-body">
					<div className="row">
						<div className="col-md-4 border-right">
							<div className="form-group">
								<label>{t('name2')}</label>
								<input type="text" className="form-control" name="name" autoComplete="off"
									value={data.name ?? ''}
									onChange={(e) => setData({ ...data, 'name': e.target.value })} />
							</div>
							<ValidPeriod data={data} setData={setData} />
							<div className="form-group">
								<label>{t('poses')}<span className="required-mark">*</span></label>
								<Select
									isMulti
									value={data.poses}
									options={poses}
									onChange={(options) => setData({ ...data, 'poses': options })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<hr />
						</div>

						<div className="col-md-4">
							<div className="form-group">
								<div className="d-flex gap-2 mb-2">
									<h4 className="fw-600">{t('discounts')}</h4>
									<div className="table-action-button table-action-primary-button"
										onClick={() => addItem()}>
										<i className="uil-plus"></i>
									</div>
								</div>
								<div className="table-responsive">
									<table className="table table-bordered mb-0">
										<thead>
											<tr>
												<th style={{ 'width': '50%' }}>{t('name2')}</th>
												<th style={{ 'width': '50%' }}>{t('discount')}%</th>
												<th style={{ 'minWidth': '33px' }}></th>
											</tr>
										</thead>
										<tbody>
											{data?.items?.map((item, index) => (
												<tr key={index}>
													<td className="td-input">
														<input type="text"
															className="form-control"
															value={item.name ?? ''}
															onChange={(e) => handleChange(e, index, 'name')} />
													</td>
													<td className="td-input">
														<input type="number"
															className="form-control"
															value={item.discount_payment_value ?? ''}
															onChange={(e) => handleChange(e, index, 'discount_payment_value')} />
													</td>
													<td style={{ 'minWidth': '33px' }}>
														<div className="table-action-button table-action-danger-button"
															onClick={() => deleteItem(item, index)}>
															<i className="uil-times"></i>
														</div>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<div className="btn-wrapper gap-2">
						<Link className="btn btn-warning btn-rounded btn-wide" to="/discount/services" tabIndex="-1">
							{t('cancel')}
						</Link>
						<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
							onClick={() => createUpdate()}>
							{t('save')}
						</button>
					</div>

				</div>
			</div>
		</>
	)
}

export default CreateUpdateCheque